import { RTL_DIRECTION } from "../constants/constants";

/**
 * Function for determining is the direction of the element RTL.
 */
export const isElementDirectionRtl = (): boolean => {
    // NOTE: Two selectors are used because there are two different widgets.
    // They can be injected independently. The function checks either widget.
    const selectors = [
        ".gw-rd-popup-widget-placeholder",
        ".gw-rd-popup-root-widget-placeholder",
    ];

    return selectors.some((selector) => {
        const element = document.querySelector(selector);

        if (!element) return false;

        const elementDirection = getComputedStyle(
            element,
            null
        ).getPropertyValue("direction");

        return elementDirection === RTL_DIRECTION;
    });
};
